<script setup>
import {ref, onMounted} from 'vue'
import ButtonSave from "@/components/common/button/ButtonSave.vue";
import {handleError} from "@/utils/errors.js";
import {useI18n} from "vue-i18n";
import router from "@/router/index.js";
import {useRoute} from "vue-router";
import EntityForm from "@/components/common/Form.vue";
import BasePage from "@/components/Layouts/BasePage.vue";
import {QrcodeEntity} from "@/entities/QrcodeEntity.js";
import {createQRCode, getQRCode, updateQRCode, listCampaigns, listCategories, listLogos} from "@/services/api/qrcode.js";

const { t } = useI18n();
const route = useRoute();
const loading = ref(false);
const id = route.params.id;
const isMounted = ref(false);
const form = ref(null);
const entity = ref(new QrcodeEntity());
const formData = ref(entity.value.getDefaultValues());
const fieldsDisabled = ref(false);

async function hydrateOptions(){
  const [camps, cats, logos] = await Promise.all([
    listCampaigns({limit:100}), listCategories({limit:100}), listLogos({limit:100})
  ]);
  const campOpts = (camps.data.items ?? camps.data ?? []).map(i=>({ label: i.name, value: i.id }));
  const catOpts = (cats.data.items ?? cats.data ?? []).map(i=>({ label: i.name, value: i.id }));
  const logoOpts = (logos.data.items ?? logos.data ?? []).map(i=>({ label: i.name, value: i.id }));
  entity.value.fields.find(f=>f.key==='campaign_id').options = campOpts;
  entity.value.fields.find(f=>f.key==='category_id').options = catOpts;
  entity.value.fields.find(f=>f.key==='logo_id').options = logoOpts;
}

async function onSave() {
  try {
    const { valid } = await form.value.validate(); if (!valid) return; loading.value = true;
    if (id) { await updateQRCode(id, formData.value); } else { await createQRCode(formData.value); }
    await router.push(entity.value.pages.list.route?.at(-1)); message.success(t("common.messages.success.save"));
  } catch (error) { console.error(error); message.error(await handleError(error, t, formData?.value?.name)); }
  finally { loading.value = false; }
}

onMounted(async () => {
  try { isMounted.value=false; await hydrateOptions(); if (id) { const response = await getQRCode(id); formData.value = response.data; } }
  catch (e) { console.error(e); } finally { isMounted.value = true; }
});
</script>

<template>
  <BasePage :loading-mounted="isMounted" :entity="entity">
    <template #default>
      <EntityForm :entity="entity" v-model="formData" :disabled="fieldsDisabled" ref="form" />
      <ButtonSave :loading="loading" @click="onSave" />
    </template>
  </BasePage>
</template>

